import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { ScrollArea, ScrollBar } from './ui/scroll-area';

// Helper to get icon based on category name keyword (simple matching)
const getCategoryIcon = (category) => {
  const lower = category.toLowerCase();
  if (lower.includes('daging') || lower.includes('ayam') || lower.includes('sapi')) return '🥩';
  if (lower.includes('ikan') || lower.includes('seafood')) return '🐟';
  if (lower.includes('sayur')) return '🥬';
  if (lower.includes('buah')) return '🍎';
  if (lower.includes('susu') || lower.includes('dairy')) return '�';
  if (lower.includes('beras') || lower.includes('nasi')) return '🍚';
  if (lower.includes('bumbu')) return '🧂';
  if (lower.includes('minuman')) return '�';
  if (lower.includes('frozen')) return '❄️';
  if (lower.includes('sembako')) return '📦';
  if (lower.includes('roti') || lower.includes('kue')) return '🍞';
  return '🛍️'; // Default
};

export const CategoryNav = ({ categories = [] }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    navigate(`/category/${encodeURIComponent(category)}`);
  };

  if (!categories || categories.length === 0) return null;

  return (
    <div className="bg-white border-b border-gray-100 py-4" data-testid="category-nav">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <ScrollArea className="w-full whitespace-nowrap">
          <div className="flex gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => handleCategoryClick(category)}
                className="flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors duration-200"
                data-testid={`category-${category}`}
              >
                <span className="text-base">{getCategoryIcon(category)}</span>
                <span>{category}</span>
              </button>
            ))}
          </div>
          <ScrollBar orientation="horizontal" />
        </ScrollArea>
      </div>
    </div>
  );
};

export default CategoryNav;
